import { Popover, Typography, Box, Container,Button } from '@material-ui/core';
import { renderField } from 'form-builder'


/**
 * This component is a popover that allows the user to view Patron Questions
 * 
 * The user can supply the following props:
 * 
 * isOpen (boolean): True if the popover is open, false otherwise
 * patron (Patron): The Patron object
 * closeCallback (function): A callback function that is called when the user clicks the close button
 */
export function PatronQuestionsViewer(props) {

    if (!props.patron || !props.patron.hasPatronQuestions())
        return null;

    const renderParams = {forPatron: false, 
                          instructionsNotInTooltip: true,
                          canEdit: false};

    return (
        <Popover open={props.isOpen}
            anchorReference="anchorPosition"
            anchorPosition={{left: window.innerWidth/2, top: window.innerHeight/2}}
            transformOrigin={{vertical: 'center', horizontal: 'center'}}>
                    
            <Box style={{margin: 20, width: window.innerWidth * 0.85}}>
                <Typography variant="subtitle1" style={{fontWeight: 'bold', marginBottom: 20}}>Patron Answered Questions</Typography>  

                {renderField(props.patron.patronQuestions.fieldTree, 0, renderParams)}

                <Container style={{display: 'flex', justifyContent: 'center', marginTop: 20, gap: 20}}>    
                    <Button onClick={props.closeCallback} variant="outlined">Close</Button>
                </Container>
            </Box>

        </Popover>
    );

}